<section class="step-four pad-bot-40">
  <div class="flex justify-content-between align-items-center">
    <div class="title fnt-20 f600">
      {{
        globalConstants.data.specialProjectConfig[projectCode]
          .giftCodeInputModalTitle
      }}
    </div>
    <img
      [src]="globalConstants.data.assets.img.visa_secure.img"
      [ngStyle]="{
        height: globalConstants.data.assets.img.visa_secure.height + 'px',
        width: globalConstants.data.assets.img.visa_secure.width + 'px'
      }"
      class="img-fluid"
      [alt]="globalConstants.data.assets.img.visa_secure.name"
    />
  </div>
  <form [formGroup]="codeForm" (submit)="codeFormSubmit()">
    <div class="pad-top-10">
      {{
        globalConstants.data.specialProjectConfig[projectCode]
          .giftCodeInputInputTitle
      }}
    </div>
    <input type="text" class="form-control" formControlName="code" />
    <div class="pad-top-10">Email</div>
    <input type="text" class="form-control" formControlName="email" />
    <button
      i18n
      class="mt-4 primary-btn new-btn flex align-items-center justify-content-center"
      type="submit"
      [disabled]="!codeForm.valid"
    >
      Continue
      <img
        src="./assets/icons/chevron-down-icon-yellow.svg"
        class="chevron-icon"
      />
    </button>
  </form>
</section>
